module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_2_L4-6ed55a496566b4fbb6df2f2171377d95.webp";